module.exports = {
    "isAnimation": true,
    "isLoop": true,
    "frames": [
        {
            "time": 0,
            "image": require("./jasmine_hover_0000.png").default
        },
        {
            "time": 200,
            "image": require("./jasmine_hover_0200.png").default
        },
        {
            "time": 400,
            "image": require("./jasmine_hover_0400.png").default
        },
        {
            "time": 600,
            "image": require("./jasmine_hover_0600.png").default
        },
        {
            "time": 1400,
            "image": require("./jasmine_hover_0800.png").default
        },
        {
            "time": 1400,
            "image": require("./jasmine_hover_1400.png").default
        },
        {
            "time": 1500,
            "image": require("./jasmine_hover_1500.png").default
        },
        {
            "time": 1600,
            "image": require("./jasmine_hover_1600.png").default
        },
        {
            "time": 2200,
            "image": require("./jasmine_hover_2200.png").default
        },
        {
            "time": 2400,
            "image": require("./jasmine_hover_2400.png").default
        },
    ]
}
